<template lang="pug">
  div(data-testid="user-edit")
    section.content-header
      h1 {{page_title}}

      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li
          router-link(:to="{name: 'user'}") ユーザー管理
        li(v-if="id === null").active ユーザー情報の作成
        li(v-else).active ユーザー情報の変更

    section.content

      app-messages(:errorMessages="errors", :successMessages="successes")

      form(ref="form", @submit.prevent="postData", novalidate)
        mixin btnbar
          .bcard-btnbar(class!=attributes.class)
            button.btn.btn-primary(type="submit", data-testid="user-edit-submit") {{action_name}}
            |
            |
            router-link.btn.btn-default(:to="{name: 'user', params:{paramGruopId: paramGruopId, paramGruopName: paramGruopName}}") キャンセル
            template(v-if="this.id")
              | &nbsp;
              .btn-separator
              | &nbsp;
              button.btn.btn-danger(type="button" @click.prevent="modalLogicalDelete = true", data-testid="user-edit-delete") 削除
              | &nbsp;
              .btn-separator
              | &nbsp;
              button.btn.btn-primary(type="button" @click.prevent="modalChgUserState = true") {{chgstate_name}}
              template(v-if="login_refused")
                | &nbsp;
                button.btn.btn-primary(type="button" @click.prevent="modalresetLoginRefused = true") ログイン拒否解除

        //- 削除済みユーザー用ボタンバー
        mixin deleted-btnbar
          .bcard-btnbar(class!=attributes.class)
            button.btn.btn-primary(type="button" @click.prevent="modalCancel = true") 削除を取り消す
            |
            |
            router-link.btn.btn-default(:to="{name: 'user', params:{paramGruopId: paramGruopId, paramGruopName: paramGruopName}}") キャンセル
            | &nbsp;
            .btn-separator
            | &nbsp;
            button.btn.btn-danger(type="button" @click.prevent="modalDelete = true", data-testid="user-edit-real-delete") データベースから削除

        template(v-if="user_state === '1'")
          +deleted-btnbar
        template(v-else)
          +btnbar

        .box.box-widget

          .box-header.with-border
            .box-title システム情報

          .box-body
            .form-group
              label.control-label(for="loginid") ログインID
                span.bcard-required (*)
              input.form-control(type="text", name="loginid", id="loginid", v-model="system.loginid", :maxlength="maxlengths.loginid", required)

            .form-group
              label.control-label(for="word_") パスワード
              input.form-control(type="password", name="word_", id="word_", v-model="system.word_", :maxlength="maxlengths.word", @input="checkNewWord")
            .form-group
              label.control-label(for="word_conf") パスワード (確認用)
              input.form-control(type="password", name="word_conf", id="word_conf", v-model="system.word_conf", :maxlength="maxlengths.word", @input="checkNewWord")

            .form-group
              label(for="level") ユーザーレベル
              .radio.radio-rich
                label
                  input(type="radio" name="level", :value="0" v-model="system.level")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | 一般ユーザー
                |
                |
                label
                  input(type="radio" name="level", :value="1" v-model="system.level")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | システム管理者

            .form-group
              label(for="bcard_exportable") 名刺情報のエクスポート
              .radio.radio-rich
                label
                  input(type="radio", name="bcard_exportable", :value="'1'", v-model="system.bcard_exportable")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | 可
                |
                |
                label
                  input(type="radio", name="bcard_exportable", :value="'0'", v-model="system.bcard_exportable")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | 不可

            .form-group.bcard-user-details-group
              label.control-label(for="group") 所属組織
              .bcard-btnbar.-bottom
                button.btn.btn-success(type='button', @click="sendGroupModalFlag")
                  | 組織選択
                button.btn.btn-default.pull-right(type='button' @click="clearDefGroup") 代表組織解除

              table.table.table-borderless.bcard-table(v-if="system.groups !== null")
                tbody
                  tr(v-for="item in system.groups", :key="item.id")
                    td.bcard-table-td-chk
                      span.bcard-deselect(title='解除' @click="setDeselectedId(item.id)")
                        i.fa.fa-times.fa-fw
                    td.bcard-ui-userdata(:title="item.name") {{item.name}}
                    td.text-right.radio.radio-rich.bcard-table-td-defgroup
                      label
                        input(type='radio' name="bcard-user-maingrp", :value="item.id" v-model="system.defgroup")
                        span: i.fa.fa-dot-circle-o.fa-lg
                        span 代表組織

        .box.box-widget

          //- 名刺情報入力エリア
          user-data(
              v-model="profile",
              :is-model-initialized="initialized",
              :file-view-mode="false",
              :area-title="title_profile"
          )

        +btnbar.-bottom

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    app-modal(v-model="modalLogicalDelete" type="danger" v-if="this.id" data-testid="user-delete-confirm")
      template(slot="title") ユーザー情報の削除
      h4 ユーザー情報を削除します。よろしいですか？
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-danger(@click="logicalDelUser") 削除
        button.btn.btn-default(@click="close") キャンセル

    app-modal(v-model="modalChgUserState" type="primary" v-if="this.id")
      template(slot="title") ユーザー情報の{{chgstate_name}}
      h4 {{chgstate_name}}にします。よろしいですか？
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-primary(@click="chgUserState") {{chgstate_name}}
        button.btn.btn-default(@click="close") キャンセル

    app-modal(v-model="modalresetLoginRefused" type="primary" v-if="this.id")
      template(slot="title") ユーザー情報のログイン拒否解除
      h4 ログイン拒否を解除します。よろしいですか？
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-primary(@click="resetLoginRefused") 解除
        button.btn.btn-default(@click="close") キャンセル

    app-modal(v-model="modalDelete" type="danger" v-if="this.id" data-testid="user-real-delete-confirm")
      template(slot="title") ユーザー情報の削除
      h4 ユーザー情報をデータベースから削除します。よろしいですか？
      .help-block
        p.bcard-comments.text-danger
          | ※ データベースから対象のユーザー情報が削除され、そのユーザーに紐づく検索キーワードや個人メモなどのユーザーデータも削除されます。
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-danger(@click="delUser") 削除
        button.btn.btn-default(@click="close") キャンセル

    app-modal(v-model="modalCancel" type="primary" v-if="this.id")
      template(slot="title") ユーザー情報の削除を取り消す
      h4 ユーザー情報の削除を取り消します。よろしいですか？
      .help-block
        p.bcard-comments.text-info
          | ※ 削除を取り消すと、このユーザーは削除済みではなく使用停止の状態になります。
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-primary(@click="chgUserState") 取り消す
        button.btn.btn-default(@click="close") キャンセル

    template(v-if="system.groups !== null")
      modal-sel-group(
        @set-groups="setGroups",
        @complete-deselection="unsetDeselectedId",
        @get-flag="initGroupModalFlag",
        :openFlag="groupModalFlag",
        :defaultGroups="system.groups",
        :deselectedId="deselectedId"
        :maxSelect="100000"
      )

</template>

<script>
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import UserData from '@/components/organisms/UserForm'
import ModalSelGroup from '@/components/organisms/ModalSelGroup'
import mixinForm from '@/mixins/form'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const UserRepository = RepositoryFactory.get('user')

export default {
  name: 'UserEdit',
  components: { AppModal, AppMessages, UserData, ModalSelGroup },
  mixins: [ mixinForm ],
  props: {
    id: {type: [String, Number], required: false, default: null},
    item: {
      type: Object,
      required: false,
      default: function () {
        return {

          name: ''
        }
      }
    },
    // 追加・変更画面から渡される初期表示の親組織
    paramGruopId: {type: Number, required: false, default: null},
    paramGruopName: {type: String, required: false, default: ''}
  },
  data: function () {
    return {
      page_title: this.id ? 'ユーザー情報の変更' : 'ユーザー情報の作成',
      action_name: this.id ? '変更' : '作成',
      title_profile: 'プロフィール情報',
      state_val: {
        ACT: '0',
        DEL: '1',
        STOP: '3'
      },
      user_state: '',
      login_refused: '',
      system: {
        loginid: '',
        word_: '',
        word_conf: '',
        level: '',
        bcard_exportable: '',
        defgroup: '',
        groups: null
      },
      // BcardDataに渡す
      profile: {
        last_name: '',
        first_name: '',
        last_kana: '',
        first_kana: '',
        corporate_name: '',
        corporate_kana: '',
        dept: '',
        post: '',
        zipcode: '',
        address1: '',
        address2: '',
        corporate_tel: '',
        dept_tel: '',
        naisen: '',
        hand_tel: '',
        fax: '',
        mail: '',
        url: '',
        images: [],
        image_id: ''
      },
      // 初期データ取得済みフラグ
      initialized: false,
      // 組織選択ダイアログに渡す選択解除ID
      deselectedId: null,
      // 各モーダルフラグ
      modalLogicalDelete: false,
      modalDelete: false,
      modalChgUserState: false,
      modalresetLoginRefused: false,
      modalCancel: false,
      // 組織選択ダイアログ表示フラグ
      groupModalFlag: false,
      maxlengths: {}
    }
  },
  computed: {
    chgstate_name: function () {
      return this.user_state === this.state_val.STOP ? '使用再開' : '使用停止'
    }
  },
  created: function () {
    const vm = this
    this.maxlengths = this.loadMaxlengths('Users')

    if (this.item.id) {
      this.system.loginid = this.item.loginid
      this.system.level = this.item.level
      this.system.bcard_exportable = this.item.bcard_exportable
      this.system.defgroup = this.item.defgroup
      this.profile.last_name = this.item.last_name
      this.profile.first_name = this.item.first_name
      this.profile.last_kana = this.item.last_kana
      this.profile.first_kana = this.item.first_kana
      this.profile.corporate_name = this.item.corporate_name
      this.profile.corporate_kana = this.item.corporate_kana
      this.profile.dept = this.item.dept
      this.profile.post = this.item.post
      this.profile.zipcode = this.item.zipcode
      this.profile.address1 = this.item.address1
      this.profile.address2 = this.item.address2
      this.profile.corporate_tel = this.item.corporate_tel
      this.profile.dept_tel = this.item.dept_tel
      this.profile.naisen = this.item.naisen
      this.profile.hand_tel = this.item.hand_tel
      this.profile.fax = this.item.fax
      this.profile.mail = this.item.mail
      this.profile.url = this.item.url
      this.user_state = this.item.user_state
      this.login_refused = this.item.login_refused
      this.initialized = true
    }
    else {
      this.system.level = this.app_flag.OFF
      this.system.bcard_exportable = this.app_flag.ON
    }

    // 変更時の初期データ
    if (this.id) {
      // API実行
      UserRepository.get(this.id)
        .then(function (response) {
          let user = vm.getApiData(response).data
          vm.system.loginid = user.loginid
          vm.system.word_ = user.word_
          vm.system.word_conf = user.word_
          vm.system.level = user.level
          vm.system.bcard_exportable = user.bcard_exportable
          vm.profile.last_name = user.last_name
          vm.profile.first_name = user.first_name
          vm.profile.last_kana = user.last_kana
          vm.profile.first_kana = user.first_kana
          vm.profile.corporate_name = user.corporate_name
          vm.profile.corporate_kana = user.corporate_kana
          vm.profile.dept = user.dept
          vm.profile.post = user.post
          vm.profile.zipcode = user.zipcode
          vm.profile.address1 = user.address1
          vm.profile.address2 = user.address2
          vm.profile.corporate_tel = user.corporate_tel
          vm.profile.dept_tel = user.dept_tel
          vm.profile.naisen = user.naisen
          vm.profile.hand_tel = user.hand_tel
          vm.profile.fax = user.fax
          vm.profile.mail = user.mail
          vm.profile.url = user.url
          vm.profile.images = user.images
          vm.profile.image_id = user.image_id
          vm.user_state = user.user_state
          vm.login_refused = user.login_refused
          vm.system.groups = []
          for (let i = 0; i < user.group_users.length; i++) {
            let group = {
              id: user.group_users[i].group.id,
              name: user.group_users[i].group.name
            }
            vm.system.groups[i] = group
          }
          vm.system.defgroup = user.defgroup ? user.defgroup : ''
          // 初期データ取得フラグを更新
          vm.initialized = true
        })
        .catch(function (error) {
          // データが無い場合は一覧へ
          vm.setErrorMessage(error)
          vm.$router.push({name: 'user', params: {paramGruopId: vm.paramGruopId, paramGruopName: vm.paramGruopName}})
          vm.$store.commit('setFlashMessages', vm.errors)
        })
    }
    // IDが渡されていない場合は初期データ取得済み扱いにする
    else {
      this.initialized = true
      this.system.groups = []
      // 一覧で組織が選択されている場合、所属にセット
      if (this.paramGruopId > 0) {
        let group = {
          id: this.paramGruopId,
          name: this.paramGruopName
        }
        vm.system.groups[0] = group
        vm.system.defgroup = this.paramGruopId
      }
    }
  },
  methods: {
    logicalDelUser: function () {
      const vm = this

      // 削除API実行
      UserRepository.logicalDelete(this.id)

        // 成功時処理
        .then(function (response) {
          // 一覧画面を表示
          if (vm.isApiSuccess(response)) {
            vm.$router.push({name: 'user', params: {paramGruopId: vm.paramGruopId, paramGruopName: vm.paramGruopName}})

          // 例外発生する？
          }
          else {
            // eslint-disable-next-line no-console
            console.log(response)
          }
        })

        // エラー時処理
        .catch(function (error) {
          vm.errors.push(vm.setErrorMessage(error))
        })
        .finally(function () {
          vm.modalLogicalDelete = false
        })
    },
    delUser: function () {
      const vm = this

      // 削除API実行
      UserRepository.physicalDelete(this.id)

        // 成功時処理
        .then(function (response) {
          // 一覧画面を表示
          if (vm.isApiSuccess(response)) {
            vm.$router.push({name: 'user', params: {paramGruopId: vm.paramGruopId, paramGruopName: vm.paramGruopName}})

          // 例外発生する？
          }
          else {
            // eslint-disable-next-line no-console
            console.log(response)
          }
        })

        // エラー時処理
        .catch(function (error) {
          vm.errors.push(vm.setErrorMessage(error))
        })
        .finally(function () {
          vm.modalDelete = false
        })
    },
    chgUserState: function () {
      const vm = this

      // 更新内容
      let params = {
        id: [this.id],
        state: this.user_state === vm.state_val.ACT || this.user_state === vm.state_val.DEL ? vm.state_val.STOP : vm.state_val.ACT
      }

      // API実行
      UserRepository.changeStatus(params)

        // 成功時処理
        .then(function (response) {
          // 一覧画面を表示
          if (vm.isApiSuccess(response)) {
            vm.$router.push({name: 'user', params: {paramGruopId: vm.paramGruopId, paramGruopName: vm.paramGruopName}})

          // アプリエラー
          }
          else {
            // eslint-disable-next-line no-console
            console.log(response)
          }
        })

        // システムエラー
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
        .finally(function () {
          vm.modalCancel = false
          vm.modalChgUserState = false
        })
    },
    resetLoginRefused: function () {
      const vm = this

      // 更新内容
      let params = {
        id: [this.id]
      }

      // API実行
      UserRepository.resetLogin(params)

        // 成功時処理
        .then(function (response) {
          // 一覧画面を表示
          if (vm.isApiSuccess(response)) {
            vm.$router.push({name: 'user', params: {paramGruopId: vm.paramGruopId, paramGruopName: vm.paramGruopName}})

          // アプリエラー
          }
          else {
            // eslint-disable-next-line no-console
            console.log(response)
          }
        })

        // システムエラー
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
        .finally(function () {
          vm.modalresetLoginRefused = false
        })
    },
    postData: function () {
      if (!this.checkFormValidity()) return

      const vm = this

      // 作成オプション
      let method = 'post'
      let params = []
      let bcardFormData = new FormData(this.$refs.form)

      // FileListからFileを削除するための苦肉の策
      bcardFormData = this.appendFiles(bcardFormData)

      // 更新オプション
      if (this.id) {
        method = 'put'
        params.push(this.id)
      }

      params.push(bcardFormData)

      // 所属
      if (vm.system.groups.length > 0) {
        let selgroups = []
        for (let i = 0; i < vm.system.groups.length; i++) {
          selgroups[i] = vm.system.groups[i].id
          bcardFormData.append('groups[]', vm.system.groups[i].id)
        }
      }
      // 代表所属
      if (vm.system.groups.length > 0) {
        bcardFormData.append('defgroup', vm.system.defgroup)
      }
      else {
        bcardFormData.append('defgroup', '')
      }

      // API実行
      UserRepository[method](...params)

        // 成功時処理
        .then(function (response) {
          // 一覧画面を表示
          if (vm.isApiSuccess(response)) {
            vm.$router.push({name: 'user', params: {paramGruopId: vm.paramGruopId, paramGruopName: vm.paramGruopName}})

          // アプリエラー
          }
          else {
            // eslint-disable-next-line no-console
            console.log(response)
          }
        })

        // システムエラー
        .catch(function (error) {
          // エラー時はメッセージを表示
          scrollTo(0, 0)
          vm.setErrorMessage(error)
        })
    },
    // ダイアログからの親組織変更イベント発火時
    setGroups: function (groups) {
      this.system.groups = []
      for (let i = 0; i < groups.length; i++) {
        let group = {
          id: groups[i].id,
          name: groups[i].name
        }
        this.system.groups[i] = group
      }
    },
    // 代表所属解除
    clearDefGroup: function () {
      this.system.defgroup = ''
    },
    // 所属解除
    clearGroup: function (id) {
      for (let i = 0; i < this.system.groups.length; i++) {
        if (this.system.groups[i].id === id) {
          this.system.groups.splice(i, 1)
        }
      }
    },
    // 組織選択ダイアログに選択を解除させる
    setDeselectedId: function (id) {
      this.deselectedId = id
    },
    // 組織選択ダイアログの選択解除完了後の処理
    unsetDeselectedId: function () {
      // 所属組織を未選択にする
      this.clearGroup(this.deselectedId)
      this.deselectedId = null
    },
    // 組織選択ダイアログにフラグを渡す
    sendGroupModalFlag () {
      this.groupModalFlag = true
    },
    // 組織選択ダイアログのフラグを更新した時点でフラグを下げる
    initGroupModalFlag () {
      this.groupModalFlag = false
    }
  }
}
</script>

<style lang="scss" scoped>
// 「代表組織」の文言を非チェック時に隠す
.bcard-user-details-group label > input:not(:checked) ~ span:last-child {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/user/Edit.vue